module.exports = __webpack_public_path__ + "img/architecture.d5b96c47.svg";